import { useMemo } from 'react';
import { useDispatch } from 'react-redux';
import {
  setNotification,
  removeNotification,
} from '../../lib/redux/notification/notificationSlice';

const useNotification = () => {
  const dispatch = useDispatch();

  const value = useMemo(
    () => ({
      showSuccess: ({ content, title = '', disappear = true }) =>
        dispatch(
          setNotification({ variant: 'success', content, title, disappear }),
        ),
      showError: ({ content, title = '', disappear = true }) =>
        dispatch(
          setNotification({ variant: 'error', content, title, disappear }),
        ),
      showDelete: ({ content, title = '', disappear = true }) =>
        dispatch(
          setNotification({ variant: 'delete', content, title, disappear }),
        ),
      showDefault: ({ content, title = '', disappear = true, id }) =>
        dispatch(
          setNotification({
            variant: 'default',
            content,
            title,
            disappear,
            id,
          }),
        ),
      handleClose: id => dispatch(removeNotification({ id })),
    }),
    [dispatch],
  );

  return value;
};

export { useNotification };
